import useAuth from "../../hooks/useAuth";
import {
  Avatar,
  Box,
  ButtonBase,
  Menu,
  MenuItem,
  IconButton as MuiIconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import * as React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components/macro";
import { getUserAvatarSrc } from "utils/userImages";

const IconButton = styled(MuiIconButton)`
  svg {
    width: 22px;
    height: 22px;
  }
`;

function NavbarUserDropdown({ showName = false, fullWidth = false }) {
  const [anchorMenu, setAnchorMenu] = React.useState(null);
  const navigate = useNavigate();
  const { signOut, user } = useAuth();
  const avatarSrc = getUserAvatarSrc(user);
  const displayName =
    user?.displayName ||
    [user?.firstName, user?.lastName].filter(Boolean).join(" ") ||
    "User";

  const toggleMenu = (event) => {
    setAnchorMenu(event.currentTarget);
  };

  const closeMenu = () => {
    setAnchorMenu(null);
  };

  const handleSignOut = async () => {
    closeMenu();
    await signOut();
    navigate("/auth/sign-in");
  };

  const triggerAvatar = (
    <Avatar
      alt={displayName}
      src={avatarSrc}
      sx={{
        bgcolor: "transparent",
        color: "inherit",
        height: 32,
        width: 32,
      }}
    />
  );

  return (
    <React.Fragment>
      {showName ? (
        <ButtonBase
          aria-owns={anchorMenu ? "menu-appbar" : undefined}
          aria-haspopup="true"
          aria-label="Open user menu"
          onClick={toggleMenu}
          sx={{
            width: fullWidth ? "100%" : "auto",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            gap: 1.5,
            px: 1.5,
            py: 1.25,
            borderRadius: 1.5,
            color: "inherit",
            border: 1,
            borderColor: "divider",
          }}
        >
          {triggerAvatar}
          <Box sx={{ minWidth: 0, flex: 1, textAlign: "left" }}>
            <Typography noWrap variant="body2" fontWeight={600}>
              {displayName}
            </Typography>
          </Box>
        </ButtonBase>
      ) : (
        <Tooltip title="Options">
          <IconButton
            aria-owns={anchorMenu ? "menu-appbar" : undefined}
            aria-haspopup="true"
            aria-label="Open user menu"
            onClick={toggleMenu}
            color="inherit"
            size="large"
          >
            {triggerAvatar}
          </IconButton>
        </Tooltip>
      )}
      <Menu
        id="menu-appbar"
        anchorEl={anchorMenu}
        open={Boolean(anchorMenu)}
        onClose={closeMenu}
      >
        <MenuItem
          onClick={() => {
            closeMenu();
            navigate("/profile");
          }}
        >
          Profile
        </MenuItem>
        <MenuItem
          onClick={() => {
            closeMenu();
            navigate("/settings/general");
          }}
        >
          Settings
        </MenuItem>
        <MenuItem onClick={handleSignOut}>Sign out</MenuItem>
      </Menu>
    </React.Fragment>
  );
}

export default NavbarUserDropdown;
